import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DepartmentsSnackbarConfig } from '../types/departments-snackbars.config';

@Injectable({
  providedIn: 'root',
})
export class DepartmentsSnackbarsService {
  private snackbar = inject(MatSnackBar);

  public successCreateActivityList(): void {
    this.snackbar.open(
      DepartmentsSnackbarConfig.successCreateActivityList.message,
      DepartmentsSnackbarConfig.successCreateActivityList.closeBtn,
      DepartmentsSnackbarConfig.successCreateActivityList.config
    );
  }

  public errorActivityList(): void {
    this.snackbar.open(
      DepartmentsSnackbarConfig.errorActivityList.message,
      null,
      DepartmentsSnackbarConfig.errorActivityList.config
    );
  }

  public successUpdateActivityList(): void {
    this.snackbar.open(
      DepartmentsSnackbarConfig.successUpdateActivityList.message,
      DepartmentsSnackbarConfig.successUpdateActivityList.closeBtn,
      DepartmentsSnackbarConfig.successUpdateActivityList.config
    );
  }

  public errorUpdateActivityList(): void {
    this.snackbar.open(
      DepartmentsSnackbarConfig.errorUpdateActivityList.message,
      null,
      DepartmentsSnackbarConfig.errorUpdateActivityList.config
    );
  }

  public successDeleteActivityList(): void {
    this.snackbar.open(
      DepartmentsSnackbarConfig.successDeleteActivityList.message,
      DepartmentsSnackbarConfig.successDeleteActivityList.closeBtn,
      DepartmentsSnackbarConfig.successDeleteActivityList.config
    );
  }

  public successAddActivity(): void {
    this.snackbar.open(
      DepartmentsSnackbarConfig.successAddActivity.message,
      DepartmentsSnackbarConfig.successAddActivity.closeBtn,
      DepartmentsSnackbarConfig.successAddActivity.config
    );
  }

  public successUpdateActivity(): void {
    this.snackbar.open(
      DepartmentsSnackbarConfig.successUpdateActivity.message,
      DepartmentsSnackbarConfig.successUpdateActivity.closeBtn,
      DepartmentsSnackbarConfig.successUpdateActivity.config
    );
  }

  public successDeleteActivity(): void {
    this.snackbar.open(
      DepartmentsSnackbarConfig.successDeleteActivity.message,
      DepartmentsSnackbarConfig.successDeleteActivity.closeBtn,
      DepartmentsSnackbarConfig.successDeleteActivity.config
    );
  }

  public successAddEmployeesToDepartment(): void {
    this.snackbar.open(
      DepartmentsSnackbarConfig.successAddEmployeesToDepartment.message,
      DepartmentsSnackbarConfig.successAddEmployeesToDepartment.closeBtn,
      DepartmentsSnackbarConfig.successAddEmployeesToDepartment.config
    );
  }

  public successRemoveEmployeeFromDepartment(): void {
    this.snackbar.open(
      DepartmentsSnackbarConfig.successRemoveEmployeeFromDepartment.message,
      DepartmentsSnackbarConfig.successRemoveEmployeeFromDepartment.closeBtn,
      DepartmentsSnackbarConfig.successRemoveEmployeeFromDepartment.config
    );
  }

  public successRegistered(): void {
    this.snackbar.open(
      DepartmentsSnackbarConfig.successRegistered.message,
      DepartmentsSnackbarConfig.successRegistered.closeBtn,
      DepartmentsSnackbarConfig.successRegistered.config
    );
  }

  public successUpdated(): void {
    this.snackbar.open(
      DepartmentsSnackbarConfig.successUpdated.message,
      DepartmentsSnackbarConfig.successUpdated.closeBtn,
      DepartmentsSnackbarConfig.successUpdated.config
    );
  }
}
